import _ from 'lodash';

// Sends `uuids` as consecutive requests of `size`, so a bulk send of thousands
// of tokens never becomes one request that runs into the server's 600 s limit.
// An empty list still makes one request, as a single send did before. Stops at
// the first failed request, or before the next request once `shouldStop()`
// returns true, and returns what was sent before it.
// `onProgress({ sent, total, inFlight })` runs before each request and once at
// the end, so a progress bar can show both what is done and what is in flight.
export const sendInChunks = async (uuids, size, sendChunk, { onProgress, shouldStop } = {}) => {
    const chunks = uuids.length ? _.chunk(uuids, size) : [[]];
    const total = uuids.length;
    const results = [];
    let sent = 0;
    for (const chunk of chunks) {
        if (shouldStop && shouldStop()) {
            if (onProgress) onProgress({ sent, total, inFlight: 0 });
            return { results, sent, error: null, stopped: true };
        }
        if (onProgress) onProgress({ sent, total, inFlight: chunk.length });
        try {
            const result = await sendChunk(chunk);
            if (Array.isArray(result)) results.push(...result);
        } catch (error) {
            return { results, sent, error, stopped: false };
        }
        sent += chunk.length;
    }
    if (onProgress) onProgress({ sent, total, inFlight: 0 });
    return { results, sent, error: null, stopped: false };
};
